const formatWaehrung = (val: number) =>
  Number(val).toLocaleString('de-DE', {
    style: 'currency',
    currency: 'EUR',
  });
/*
const formatNumber = (val: number, grouped = true) =>
  Number(val).toLocaleString('de-DE', {
    useGrouping: grouped,
  });

const formatFraction = (val: number, minDigits = 2, maxDigits = 2, grouped = true) =>
  Number(val).toLocaleString('de-DE', {
    minimumFractionDigits: minDigits,
    maximumFractionDigits: maxDigits,
    useGrouping: grouped,
  });
*/
const NumberUtil = {
  formatWaehrung
}
export default NumberUtil;
